import { Icon, IconName } from '@pm/ui';
import { twMerge } from 'tailwind-merge';

type EncounterDetailProps = {
  iconName?: IconName;
  align?: 'center' | 'start';
  children: React.ReactNode;
};

export const EncounterDetail = ({
  iconName,
  align = 'center',
  children,
}: EncounterDetailProps) => {
  return (
    <div
      className={twMerge(
        'flex space-x-s',
        align === 'center' ? 'items-center' : 'items-start',
      )}
    >
      {iconName && <Icon name={iconName} size="xl" />}
      {children}
    </div>
  );
};
